import { useState } from 'react';
import { useGetSchools } from '@/api/hooks';
import {
  useGetSchoolsProposals,
  useGetSchoolsStatistics,
} from '@/api/hooks/useSchool';
import { ColumnDefinition } from '@/components/Ui/DataTable/DataTable.type';
import { useSchoolStore } from '@/store/SchoolStore/SchoolStore';

const columns: ColumnDefinition[] = [
  { field: 'school', header: 'Ecole' },
  { field: 'region', header: 'Région' },
  { field: 'privateOrPublic', header: 'Privée ou publique' },
  { field: 'number', header: 'Nombre' },
];

export const useSchools = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const {
    schoolListlimit,
    setSchoolListLimit,
    schoolListPage,
    setSchoolListPage,
  } = useSchoolStore();
  const { data: schools, isLoading: loadingSchools } = useGetSchools({
    limit: schoolListlimit,
  });
  const { data: schoolsProposals, isLoading: loadingSchoolsProposals } =
    useGetSchoolsProposals({ limit: schoolListlimit });

  const { data: schoolStats, isLoading: loadingStats } =
    useGetSchoolsStatistics();

  const schoolsList = schools?.map((item) => {
    const list = {
      id: item?._id,
      school: item?.name,
      region: item.region?.name,
      privateOrPublic: item?.type,
      number: item.totalStudents ?? 0,
    };
    return list;
  });

  const schoolsProposalsList = schoolsProposals?.map((item) => {
    const list = {
      id: item._id,
      school: item.name,
      region: item.region.name,
      privateOrPublic: item.type,
      number: item.totalStudents ?? 0,
    };
    return list;
  });

  return {
    schoolsList,
    schoolsProposalsList,
    loadingSchools,
    loadingSchoolsProposals,
    activeTab,
    setActiveTab,
    columns,
    schoolListlimit,
    setSchoolListLimit,
    schoolListPage,
    setSchoolListPage,
    schoolStats,
    loadingStats,
  };
};
